import React from 'react';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import ActionButton from '../../../elements/ActionButton/ActionButton';
import Icon from '../../../elements/icons/Icon';
import linkedinIcon from '../../../../resources/icons/LinkedIn_icon.png';

function LinkedinContactButton(props) {
    const { className = '', user } = props,
        i18n = useI18n();

    if (!user.linkedin_profile_url) return null;

    return (
        <ActionButton
            className={className}
            icon={<Icon src={linkedinIcon} width={40} />}
            primary
            tab
            href={user.linkedin_profile_url}
            next>
            {i18n['label.linkedin-view-profile']}
        </ActionButton>
    );
}

export default LinkedinContactButton;
